type SelectbuttonSize = 'default' | 'lg' | 'xl' | 'pc' | 'pc-chip'

/**
 * 시안 컴포넌트 세트 `Selectbutton`(1320:18328)의 변형별 값.
 * **min·max 폭이 변형마다 정해져 있다** — 칩이 너무 좁아지거나 넓어지지 않게 막는 값이라
 * 호출부가 아니라 여기가 갖는다.
 *
 * | 코드 사이즈 | 시안 변형 | 높이 | min | max |
 * | --- | --- | --- | --- | --- |
 * | `lg` | Mobile&PC · Medium | 58 | 150 | — |
 * | `pc` | PC · Large | 64 | 150 | 193 |
 * | `pc-chip` | PC · Medium | 58 | 150 | — |
 * | `xl` | Mobile · XLarge | 90 | 167 | — |
 *
 * `default` 는 이 세트의 Mobile·Small(h 50 · min 165)과 높이가 달라 짝을 짓지 않았다 —
 * 거기에 min 165 를 넣으면 필터 화면의 3열 칩(약 109px)이 넘친다(실측 2026-09-07).
 */
const SIZE: Record<SelectbuttonSize, string> = {
  default: 'h-11 rounded-[10px] px-4 py-2 text-body-md',
  lg: 'h-[58px] min-w-[150px] rounded-[14px] px-3.5 py-2 text-body-lg-reading',
  pc: 'h-16 min-w-[150px] max-w-[193px] rounded-[14px] px-3.5 py-2 text-body-lg-reading',
  // 글자가 16px 인 것까지 시안 값이다 — 같은 58px 높이인 `lg`(18px)와 다르다.
  'pc-chip': 'h-[58px] min-w-[150px] rounded-[14px] px-[30px] py-[18px] text-body-md',
  xl: 'h-[90px] min-w-[167px] rounded-[14px] px-3.5 py-2 text-body-lg-reading',
}

export function Selectbutton({
  label,
  isOn,
  onSelect,
  isBlocked = false,
  size = 'default',
  className = '',
}: {
  label: string
  isOn: boolean
  onSelect: () => void
  isBlocked?: boolean
  size?: SelectbuttonSize
  className?: string
}) {
  return (
    <button
      type="button"
      className={[
        'ui-selectbutton ui-pressable',
        // 시안 컴포넌트도 `overflow: clip` 이다 — 폭을 넘는 글자는 잘린다.
        'cursor-pointer overflow-hidden border text-center',
        SIZE[size],
        isOn
          ? // State=Select — 글자가 Medium 으로 굵어지는 것까지 시안 값이다.
            'is-on border-violet-700 bg-violet-100 font-medium text-violet-700'
          : 'border-white-300 bg-white-50 text-black-600',
        // 상한에 걸린 상태는 **시안에 없다.** 누를 수 없다는 것만 색으로 알린다.
        'disabled:cursor-default disabled:text-white-900',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-pressed={isOn}
      disabled={isBlocked && !isOn}
      onClick={onSelect}
    >
      {label}
    </button>
  )
}
